export enum AutoAttachmentSourceType {
  ACOMBAGO = 'ACOMBAGO',
}

export enum AutoAttachmentSourceSubType {
  INVOICE = 'INVOICE',
  CREDIT = 'CREDIT',
  STATEOFACCOUNT = 'STATEOFACCOUNT',
}

export interface AutoAttachmentDto {
  id: string;
  fileName: string;
  fileType: string | null;
  fileSizeBytes: number | null;
  sourceType: AutoAttachmentSourceType;
  sourceSubType: AutoAttachmentSourceSubType | null;
  sourceReference: string | null;
}
